export default "__VITE_ASSET__dc9d54fb__"